var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_warning_24px",
    d: "M1,21H23L12,2Zm12-3H11V16h2Zm0-4H11V10h2Z",
    transform: "translate(-1 -2)",
    fill: "#ff9100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarning);
export default __webpack_public_path__ + "static/media/ic_warning.c9a5e8f54193b87902d10cf5592f199a.svg";
export { ForwardRef as ReactComponent };